// extracted by mini-css-extract-plugin
export var container = "_lg-0";
export var outlet = "_lg-1";
export var outletEnter = "_lg-2";
export var outletEnterActive = "_lg-3";
export var outletExit = "_lg-4";
export var outletExitActive = "_lg-5";